import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, calculateAge, getCurrentDateTime, request, toast } from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { REPORT_TYPE } from '../../../../../constants/dropdown';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';


export const TpaClaimAmountReportStatus = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [userdata, setUserData] = useState([]);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],

    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;
  const user = JSON.parse(localStorage.getItem('user'));

  const getUserList = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user`);
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
  }, []);

  useEffect(() => {
    getUserList();
  }, []);

const handleExcelReport = async () => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  try {
    const response = await axios.get(
      `${BASE_URL}/print/hospital/tpa/tpa-claim-amount-status-report?refId=${JSON.stringify({
        from_date: watch('from_date'),
        to_date: watch('to_date')
      })}`
    );
    if (response?.data?.success) {
      const tpaData = response.data.data;
      if (tpaData && tpaData.length > 0) {
        const formattedData = tpaData.map((item, index) => ({
          'Sr. No.': index + 1,
          'Patient Name': `${item?.patient.name_suffix || ''} ${item?.patient.first_name || ''} ${item?.patient.last_name || ''}`.trim(),
          'Age': calculateAge(item?.patient.dob),
          'Claim Id': item?.claim_id,
          'Uhid No.': item?.uhid || '',
          'IPD No.': item?.ipd_no || '',
          'Consultant': item?.ipdPatient?.doctor?.name || '',
          'Sponsor': item?.patient.sponsor?.name || '',
          'Bill Amt': item?.bill_amt || 0,
          'Initial Amt.': item?.initial_amt || 0,
          'Claim Amt.': item?.claim_amt || 0,
          'Recd Amt.': item?.received_amt || 0,
          'TDS Amt.': item?.tds_amt || 0,
          'Hospital Disc': item?.hospital_disc || 0,
          "Co Payment": item?.co_payment || 0,
          "Other Charges": item.other_charges || 0,
        }));
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const columnWidths = Object.keys(formattedData[0]).map(() => ({ wch: 12 })); 
        worksheet['!cols'] = columnWidths;
        const workbook = { Sheets: { 'TPA Report': worksheet }, SheetNames: ['TPA Report'] };
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, `TPA_Report_${Date.now()}${fileExtension}`);
      } else {
        toast('No data found for the selected period', { variant: 'info' });
      }
    } else {
      toast('Something went wrong while fetching data', { variant: 'error' });
    }
  } catch (error) {
    console.error(error);
    toast('Failed to generate report', { variant: 'error' });
  }
};

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
               TPA Claim Amount Status Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  onClick={() => 
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({from_date: watch('from_date'),to_date: watch('to_date')})}`, 
                      '_blank'
                    )
                  }
                >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  onClick={handleExcelReport}
                >
                  View Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                  </Stack>  
              </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>

    </>
  );
};
